import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    'MuiFormControlLabel-root': {
      flexWrap: 'wrap',
    },
    label: {
      color: theme.palette.form.labelColor,
      fontSize: theme.typography.fontSize,
      marginBottom: 5,
      marginTop: 5,
    },
    radioLabel: {
      flexWrap: 'wrap',
      '& .MuiIconButton-root': {
        padding: ' 5px 9px',
      },
      '& .MuiFormControlLabel-label': {
        color: theme.palette.form.labelColor,
        fontSize: theme.typography.fontSize,
      },
    },
    subLabel: {
      padding: '0 43px',
      width: '100%',
      order: 2,
      marginTop: '-6px',
      marginBottom: '12px',
      color: theme.palette.form.labelColor,
      opacity: '0.8',
      fontSize: theme.typography.fontSize - 0.5,
    },
  };
});

export default useStyles;
